import {
  hasPermissionToAccess,
  PERMISSION_TYPE,
} from '@common-packages/customer-permissions-utils';

const hasRequiredPermissionsToEdit = (customerPermissions, path) =>
  hasPermissionToAccess({
    customerPermissions,
    permissionType: PERMISSION_TYPE.EDIT,
    routeDefinitions: [path],
  });

export default hasRequiredPermissionsToEdit;
